import React, { useState } from "react";
import { Form, Button, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import DefaultImage from "../assets/images/avatar_woman1.svg"; 
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { PiCameraFill } from "react-icons/pi";

const AccountInfo = () => {
    const [image, setImage] = useState(DefaultImage); // Default image

    const handleImageChange = (event) => {
        const file = event.target.files[0];

        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setImage(reader.result); // Update the profile picture preview
            };
            reader.readAsDataURL(file);
        }
    };

    
    const [email, setEmail] = useState('rose.winslet@gmail.com'); // Default email
    const [username, setUsername] = useState('rosewinslet'); // Default username
    const [firstName, setFirstName] = useState('Rose'); // Default first name
    const [lastName, setLastName] = useState('Winslet'); // Default last name
    const [dobDay, setDobDay] = useState('10'); // Default day
    const [dobMonth, setDobMonth] = useState('9'); // Default month
    const [dobYear, setDobYear] = useState('2000'); // Default year
    const [country, setCountry] = useState('South korea'); // Default country
    const [gender, setGender] = useState('Female'); // Default gender
    const [phoneNumber, setPhoneNumber] = useState('1234567890'); // Default phone number
    const [selectedCode, setSelectedCode] = useState("+82"); // Default country code
    const [message, setMessage] = useState('This is my bio.'); // Default message/bio
    const navigate = useNavigate(); // Use useNavigate instead of useHistory

    // Example countries (replace with your actual list)
    const countries = ['South korea', 'United States', 'Canada', 'United Kingdom', 'Australia'];

    const genders = ['Male', 'Female', 'Other'];

    const countryCodes = [
        { code: "+1", country: "United States / Canada" },
        { code: "+7", country: "Russia / Kazakhstan" },
        { code: "+20", country: "Egypt" },
        { code: "+27", country: "South Africa" },
        { code: "+30", country: "Greece" },
        { code: "+31", country: "Netherlands" },
        { code: "+32", country: "Belgium" },
        { code: "+33", country: "France" },
        { code: "+34", country: "Spain" },
        { code: "+36", country: "Hungary" },
        { code: "+39", country: "Italy" },
        { code: "+40", country: "Romania" },
        { code: "+41", country: "Switzerland" },
        { code: "+43", country: "Austria" },
        { code: "+44", country: "United Kingdom" },
        { code: "+45", country: "Denmark" },
        { code: "+46", country: "Sweden" },
        { code: "+47", country: "Norway" },
        { code: "+48", country: "Poland" },
        { code: "+49", country: "Germany" },
        { code: "+51", country: "Peru" },
        { code: "+52", country: "Mexico" },
        { code: "+53", country: "Cuba" },
        { code: "+54", country: "Argentina" },
        { code: "+55", country: "Brazil" },
        { code: "+56", country: "Chile" },
        { code: "+57", country: "Colombia" },
        { code: "+58", country: "Venezuela" },
        { code: "+60", country: "Malaysia" },
        { code: "+61", country: "Australia" },
        { code: "+62", country: "Indonesia" },
        { code: "+63", country: "Philippines" },
        { code: "+64", country: "New Zealand" },
        { code: "+65", country: "Singapore" },
        { code: "+66", country: "Thailand" },
        { code: "+81", country: "Japan" },
        { code: "+82", country: "South Korea" },
        { code: "+84", country: "Vietnam" },
        { code: "+86", country: "China" },
        { code: "+90", country: "Turkey" },
        { code: "+91", country: "India" },
        { code: "+92", country: "Pakistan" },
        { code: "+93", country: "Afghanistan" },
        { code: "+94", country: "Sri Lanka" },
        { code: "+95", country: "Myanmar" },
        { code: "+98", country: "Iran" },
        { code: "+211", country: "South Sudan" },
        { code: "+212", country: "Morocco" },
        { code: "+213", country: "Algeria" },
        { code: "+216", country: "Tunisia" },
        { code: "+218", country: "Libya" },
        { code: "+220", country: "Gambia" },
        { code: "+221", country: "Senegal" },
        { code: "+222", country: "Mauritania" },
        { code: "+223", country: "Mali" },
        { code: "+224", country: "Guinea" },
        { code: "+225", country: "Ivory Coast" },
        { code: "+226", country: "Burkina Faso" },
        { code: "+227", country: "Niger" },
        { code: "+228", country: "Togo" },
        { code: "+229", country: "Benin" },
        { code: "+230", country: "Mauritius" },
        { code: "+231", country: "Liberia" },
        { code: "+232", country: "Sierra Leone" },
        { code: "+233", country: "Ghana" },
        { code: "+234", country: "Nigeria" },
        { code: "+235", country: "Chad" },
        { code: "+236", country: "Central African Republic" },
        { code: "+237", country: "Cameroon" },
        { code: "+238", country: "Cape Verde" },
        { code: "+239", country: "São Tomé and Príncipe" },
        { code: "+240", country: "Equatorial Guinea" },
        { code: "+241", country: "Gabon" },
        { code: "+242", country: "Congo" },
        { code: "+243", country: "Democratic Republic of Congo" },
        { code: "+244", country: "Angola" },
        { code: "+245", country: "Guinea-Bissau" },
        { code: "+246", country: "British Indian Ocean Territory" },
        { code: "+248", country: "Seychelles" },
        { code: "+249", country: "Sudan" },
        { code: "+250", country: "Rwanda" },
        { code: "+251", country: "Ethiopia" },
        { code: "+252", country: "Somalia" },
        { code: "+253", country: "Djibouti" },
        { code: "+254", country: "Kenya" },
        { code: "+255", country: "Tanzania" },
        { code: "+256", country: "Uganda" },
        { code: "+257", country: "Burundi" },
        { code: "+258", country: "Mozambique" },
        { code: "+260", country: "Zambia" },
        { code: "+261", country: "Madagascar" },
        { code: "+262", country: "Réunion" },
        { code: "+263", country: "Zimbabwe" },
        { code: "+264", country: "Namibia" },
        { code: "+265", country: "Malawi" },
        { code: "+266", country: "Lesotho" },
        { code: "+267", country: "Botswana" },
        { code: "+268", country: "Eswatini" },
        { code: "+269", country: "Comoros" },
        { code: "+290", country: "Saint Helena" },
        { code: "+291", country: "Eritrea" },
        { code: "+297", country: "Aruba" },
        { code: "+298", country: "Faroe Islands" },
        { code: "+299", country: "Greenland" }
    ];


    const [errors, setErrors] = useState({});

    const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    const resetForm = () => {
        setEmail('');
        setUsername('');
        setFirstName('');
        setLastName('');
        setDobDay('');
        setDobMonth('');
        setDobYear('');
        setCountry('');
        setGender('');
        setPhoneNumber('');
        setSelectedCode("+1"); // Reset country code
        setMessage('');
        setErrors({}); // Clear validation errors
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Validate form fields
        const newErrors = {};

        if (!email || !validateEmail(email)) {
            newErrors.email = 'Please enter a valid email.';
        }

        if (!username) {
            newErrors.username = 'Username is required.';
        }

        if (!firstName) {
            newErrors.firstName = 'First name is required.';
        }

        if (!lastName) {
            newErrors.lastName = 'Last name is required.';
        }

        if (!dobDay || !dobMonth || !dobYear) {
            newErrors.dob = 'Please select a valid date of birth.';
        }

        if (!country) {
            newErrors.country = 'Please select a country.';
        }

        if (!phoneNumber) {
            newErrors.phoneNumber = 'Please select a phone number.';
        }

        // Update errors state
        setErrors(newErrors);

        // ✅ Stop submission if there are errors
        if (Object.keys(newErrors).length > 0) {
            return;
        }


        // ✅ Navigate to home page
        navigate("/");
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                {/* Profile Photo Section */}
                <Col md={4}>
                    <span className="form-lable-content">Profile Photo</span>
                    <div className="profile-container">
                        <div className="profile-wrapper">
                            <img src={image} alt="Profile" className="profile-image" />
                            <label htmlFor="fileInput" className="upload-icon">
                                <PiCameraFill />
                            </label>
                            <Form.Control
                                type="file"
                                id="fileInput"
                                accept="image/*"
                                onChange={handleImageChange}
                                className="file-input"
                            />
                        </div>
                    </div>
                </Col>

                {/* Profile Details Form */}
                <Col md={8}>
                    <span className="form-lable-content">Profile Details</span>
                    {/* Email Input Group with Validation */}
                    <div className="mb-3">
                        <Form.Floating>
                            <Form.Control
                                id="floatingEmailCustom"
                                type="email"
                                placeholder="name@example.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className={errors.email ? 'is-invalid' : ''}
                            />
                            <label htmlFor="floatingEmailCustom">Email </label>
                        </Form.Floating>
                        {errors.email && <div className="text-danger mt-1">{errors.email}</div>} {/* ✅ Email error message */}
                    </div>

                    {/* Username Input Group with Validation */}
                    <div className="mb-3">
                        <Form.Floating>
                            <Form.Control
                                id="floatingUsernameCustom"
                                type="text"
                                placeholder="Username"
                                value={username}
                                onChange={(e) => setUsername(e.target.value)}
                                className={errors.username ? 'is-invalid' : ''}
                            />
                            <label htmlFor="floatingUsernameCustom">Username</label>
                        </Form.Floating>
                        {errors.username && <div className="text-danger mt-1">{errors.username}</div>} {/* ✅ Username error message */}
                    </div>

                    {/* First Name Input Group with Validation */}
                    <div className="row mb-3 gx-2">
                        {/* First Name Input Group with Validation */}
                        <div className="col-6">
                            <Form.Floating>
                                <Form.Control
                                    id="floatingFirstNameCustom"
                                    type="text"
                                    placeholder="First Name"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    className={errors.firstName ? 'is-invalid' : ''}
                                />
                                <label htmlFor="floatingFirstNameCustom">First Name</label>
                            </Form.Floating>
                            {errors.firstName && <div className="text-danger mt-1">{errors.firstName}</div>} {/* ✅ First Name error message */}
                        </div>

                        {/* Last Name Input Group with Validation */}
                        <div className="col-6">
                            <Form.Floating>
                                <Form.Control
                                    id="floatingLastNameCustom"
                                    type="text"
                                    placeholder="Last Name"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    className={errors.lastName ? 'is-invalid' : ''}
                                />
                                <label htmlFor="floatingLastNameCustom">Last Name</label>
                            </Form.Floating>
                            {errors.lastName && <div className="text-danger mt-1">{errors.lastName}</div>} {/* ✅ Last Name error message */}
                        </div>
                    </div>

                    {/* Date of Birth Select Dropdowns with Validation */}
                    <div className="mb-3">
                        <div className="d-flex d-flex-time">
                            {/* Day Dropdown with Floating Label */}
                            <div className="flex-fill me-2">
                                <FloatingLabel controlId="floatingDay" label="Day">
                                    <Form.Select
                                        aria-label="Day"
                                        value={dobDay}
                                        onChange={(e) => setDobDay(e.target.value)}
                                        className={errors.dob ? 'is-invalid' : ''}
                                    >
                                        <option value="">Day</option>
                                        {[...Array(31)].map((_, i) => (
                                            <option key={i} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </FloatingLabel>
                            </div>

                            {/* Month Dropdown with Floating Label */}
                            <div className="flex-fill me-2">
                                <FloatingLabel controlId="floatingMonth" label="Month">
                                    <Form.Select
                                        aria-label="Month"
                                        value={dobMonth}
                                        onChange={(e) => setDobMonth(e.target.value)}
                                        className={errors.dob ? 'is-invalid' : ''}
                                    >
                                        <option value="">Month</option>
                                        {[...Array(12)].map((_, i) => (
                                            <option key={i} value={i + 1}>
                                                {i + 1}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </FloatingLabel>
                            </div>

                            {/* Year Dropdown with Floating Label */}
                            <div className="flex-fill">
                                <FloatingLabel controlId="floatingYear" label="Year">
                                    <Form.Select
                                        aria-label="Year"
                                        value={dobYear}
                                        onChange={(e) => setDobYear(e.target.value)}
                                        className={errors.dob ? 'is-invalid' : ''}
                                    >
                                        <option value="">Year</option>
                                        {[...Array(100)].map((_, i) => (
                                            <option key={i} value={2022 - i}>
                                                {2022 - i}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </FloatingLabel>
                            </div>
                        </div>

                        {errors.dob && <div className="text-danger mt-1">{errors.dob}</div>} {/* Date of Birth error message */}
                    </div>

                    {/* Gender Dropdown with Validation */}
                    <div className="mb-3">
                        <FloatingLabel controlId="floatingSelect" label="Gender">
                            <Form.Select
                                aria-label="Gender"
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}
                                className={errors.gender ? 'is-invalid' : ''}
                            >
                                <option value="">Gender</option>
                                {genders.map((gender, index) => (
                                    <option key={index} value={gender}>
                                        {gender}
                                    </option>
                                ))}
                            </Form.Select>
                        </FloatingLabel>
                        {errors.gender && <div className="text-danger mt-1">{errors.gender}</div>} {/* ✅ gender error message */}
                    </div>

                    {/* Phone Number Section */}
                    <Row className="mb-3 gx-2">
                        <Col xs={4}>
                            <FloatingLabel controlId="floatingCountryCode" label="Area Code">
                                <Form.Select
                                    value={selectedCode}
                                    onChange={(e) => setSelectedCode(e.target.value)}
                                >
                                    {countryCodes.map((c, index) => (
                                        <option key={index} value={c.code}>
                                            {c.code} ({c.country})
                                        </option>
                                    ))}
                                </Form.Select>
                            </FloatingLabel>
                        </Col>

                        <Col xs={8}>
                            <FloatingLabel controlId="floatingPhoneNumber" label="Phone Number">
                                <Form.Control
                                    type="tel"
                                    placeholder="Phone Number"
                                    value={phoneNumber}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, ""); // Remove non-numeric characters
                                        if (value.length <= 17) {
                                            setPhoneNumber(value);
                                        }
                                    }}
                                    className={errors.phoneNumber ? "is-invalid" : ""}
                                />
                            </FloatingLabel>
                        </Col>
                        {errors.phoneNumber && <div className="text-danger mb-3">{errors.phoneNumber}</div>}
                    </Row>
                   


                    {/* Country Dropdown with Validation */}
                    <div className="mb-3">
                        <FloatingLabel controlId="floatingSelect" label="Country">
                            <Form.Select
                                aria-label="Country"
                                value={country}
                                onChange={(e) => setCountry(e.target.value)}
                                className={errors.country ? 'is-invalid' : ''}
                            >
                                <option value="">Country</option>
                                {countries.map((country, index) => (
                                    <option key={index} value={country}>
                                        {country}
                                    </option>
                                ))}
                            </Form.Select>
                        </FloatingLabel>
                        {errors.country && <div className="text-danger mt-1">{errors.country}</div>} {/* ✅ Country error message */}
                    </div>

                    {/* Message Input Group with Validation */}
                    <div className="mb-3">
                        <Form.Floating>
                            <Form.Control
                                as="textarea"
                                id="floatingMessageCustom"
                                placeholder="Enter your message"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                className={errors.message ? 'is-invalid' : ''}
                                style={{ height: "150px" }} // Adjust height as needed
                            />
                            <label htmlFor="floatingMessageCustom">Bio</label>
                        </Form.Floating>
                        {errors.message && <div className="text-danger mt-1">{errors.message}</div>} {/* ✅ Message error message */}
                    </div>


                    <div className="form-buttons">
                        <Button type="submit" size="lg" className="btn btn-primary">Save Changes</Button>
                        <Button variant="link" onClick={resetForm}>Discard</Button>
                    </div>
                </Col>
            </Row>
        </Form>
    );
};

export default AccountInfo;